(function () {
    angular
        .module("dashboard")
        .component("storeOrders",
            {
                template: "<div><div ui-view=\"orderview\"></div></div>"
            });
})();
